module.exports = __webpack_public_path__ + "media/images/lb/878-b68b29407aa5f9bada118f2115a9f2d7.svg";